import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const TypTitle = {
  overflowWrap: 'anywhere',
  marginBottom: 2.5, 
  lineHeight: '30px',

  [PureLightTheme.breakpoints.down("sm")]: {
    fontSize: "20px",
    marginBottom: 1.5, 
  }
}

export const TabsStyle = {
  position: 'relative',
  '& .MuiTabScrollButton-root': {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    opacity: 1,
    '&.Mui-disabled': {
      opacity: 0,
    },
  },
  '& .MuiTabScrollButton-root:first-of-type': { 
    background: `linear-gradient(to right, ${COLORS.SNOW_DRIFT} 60%, transparent 100%)`,
    left: 0,
  },
  '& .MuiTabScrollButton-root:last-of-type': { 
    background: `linear-gradient(to left, ${COLORS.SNOW_DRIFT} 60%, transparent 100%)`,
    right: 0,
  },
}
